var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 2.875H2.84821C1.27679 2.875 0 4.17773 0 5.77695V40.223C0 41.8223 1.27679 43.125 2.84821 43.125H37.1429C38.7143 43.125 40 41.8223 40 40.223V5.77695C40 4.17773 38.7143 2.875 37.1429 2.875ZM12.0893 37.375H6.16071V18.1664H12.0982V37.375H12.0893ZM9.125 15.543C7.22321 15.543 5.6875 13.9887 5.6875 12.084C5.6875 10.1793 7.22321 8.625 9.125 8.625C11.0179 8.625 12.5625 10.1793 12.5625 12.084C12.5625 13.9977 11.0268 15.543 9.125 15.543ZM34.3125 37.375H28.3839V28.0312C28.3839 25.8031 28.3393 22.9371 25.3036 22.9371C22.2143 22.9371 21.7411 25.3629 21.7411 27.8695V37.375H15.8125V18.1664H21.5V20.7898H21.5804C22.375 19.2805 24.3125 17.6902 27.1964 17.6902C33.1964 17.6902 34.3125 21.6703 34.3125 26.8453V37.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBrands);
export default __webpack_public_path__ + "static/media/linkedin-brands.9a970605d1b642ecf4da1eae68c4adf0.svg";
export { ForwardRef as ReactComponent };